import {useEffect, useState} from "react";
import {useFormik} from "formik";
import {Dropdown, Form, Modal, Button} from "react-bootstrap";
import {Roles, Usuarios} from "../../../components/catalogo/CatalogosTareas";
import {axiosInstance} from "../../../components/helpers/axiosInstance";

export default function Miembros({
     showMiembros,
     setShowMiembros,
     m,
     idTask
}){
    const [miembros, setMiembros] = useState([]);
    const [addUser, setAddUser] = useState(false);
    const rolesLS = JSON.parse(localStorage.getItem('roles'));
    const miembrosLS = JSON.parse(localStorage.getItem('miembros'));

    const onSubmit = async (values) => {

        axiosInstance.post('/todo/miembros/', values)
            .then((res) => {
                const newM = miembrosLS.filter((m) => m.id_usuario === values.id_usuario);
                setMiembros([
                    ...miembros, {
                        id_miembro: res.data.id_miembro,
                        usuario: {
                            id_usuario: newM[0].id_usuario,
                            username: newM[0].usuario,
                            avatar: newM[0].avatar
                        },
                        rol: values.rol,
                    }
                ])
                setAddUser(false);
                formik.resetForm();
            }).catch(err => console.error(err));

        await new Promise( (resolve) => setTimeout(resolve, 1000));
    }

    const formik = useFormik({
        initialValues : {
            id_usuario: null,
            id_tarea: idTask,
            rol: null
        },
        onSubmit
    });

    useEffect(() => {
        setMiembros(m);
    }, [m]);

    function deleteMember(id){
        axiosInstance.delete('/todo/miembros/', { data: {
                id_miembro: id
            }}).then((res) => {
            res.status === 200 && setMiembros(miembros.filter(m => m.id_miembro !== id));
        })
            .catch((err) => console.error(err));
    }

    function updateMember(id, rol){
        axiosInstance.put('/todo/miembros/', {
            id_miembro: id,
            rol: rol
        }).then((res) => {
            if (res.status === 200){
                setMiembros(
                    miembros.map((m) => {
                        if (m.id_miembro === id){
                            return {
                                ...m,
                                rol: rol
                            }
                        } else {
                            return m;
                        }
                    })
                )
            }
        })
            .catch((err) => console.error(err));
    }
    return(
        <>
            <style type={'text/css'}>
                {`
                    .dropdown-menu {
                        z-index : 1060!important;
                    }
                `}
            </style>
            <Modal
                show={showMiembros}
                onHide={() => setShowMiembros(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Miembros disponibles
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className=" me-n7 pe-7">
                        {
                            miembros && miembros.map((m, index) => {
                                return (
                                    <div key={m.id_miembro}
                                         className={"d-flex flex-stack py-3 " + (index + 1 !== miembros.length && "border-bottom border-gray-300 border-bottom-dashed")}>
                                        <div className="d-flex align-items-center">
                                            <div className="symbol symbol-35px symbol-circle">
                                            <span
                                                className={"symbol-label fw-semibold " + m.usuario.avatar}>{m.usuario.avatar}</span>
                                            </div>
                                            <div className="ms-6">
                                                <button type={'button'}
                                                    className="btn p-0 d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary text-capitalize">{m.usuario.username}
                                                    <span
                                                        className="badge badge-light fs-8 fw-semibold ms-2">{m.rol}</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <div className="text-end">
                                                <Dropdown style={{display: "contents", zIndex: 1060}} onSelect={(eventKey) => updateMember(m.id_miembro, eventKey)}>
                                                    <Dropdown.Toggle variant={'secondary'} className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                                        <i className="ki-duotone ki-pencil fs-4 text-primary">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {
                                                            rolesLS && rolesLS.map((r) => {
                                                                return (
                                                                    m.rol !== r.descripcion && <Dropdown.Item key={r.valor} eventKey={r.valor}>{r.descripcion}</Dropdown.Item>
                                                                );
                                                            })
                                                        }
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                <button type={'button'} className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm" onClick={() => deleteMember(m.id_miembro)}>
                                                    <i className="ki-duotone ki-trash fs-4 text-primary">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                        <span className="path3"></span>
                                                        <span className="path4"></span>
                                                        <span className="path5"></span>
                                                    </i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type={'button'} variant="secondary" onClick={() => setShowMiembros(false)}>
                        Cerrar
                    </Button>
                    <div className="text-muted fw-semibold mt-2">
                        <button type={'button'} className="btn btn-primary" onClick={() => setAddUser(true)}>Agregar miembro</button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={addUser} onHide={() => setAddUser(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Seleccione usuario
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={formik.handleSubmit} id={'agregarUsuario'} className={'d-flex row justify-content-around'}>
                        <div className={'col-md-6'}>
                            <Usuarios setFieldValue={formik.setFieldValue} values={formik.values.id_usuario} disableOpc={miembros}></Usuarios>
                        </div>
                        <div className={'col-md-6'}>
                            <Roles setFieldValue={formik.setFieldValue} values={formik.values}></Roles>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button type={'button'} variant={'secondary'} onClick={() => setAddUser(false)}>Cerrar</Button>
                    <Button className={"btn btn-primary"} type={'submit'} form={'agregarUsuario'} disabled={formik.values.rol === null || formik.values.id_usuario === null}>Agregar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
